import { ui } from '@procuros/datachecks';

// Types for worker communication

export type DataStores = Record<string, Record<string, unknown>>;

export type WorkerErrorDiagnostics = {
  inputType?: string;
  dataShape?: string;
  specificationShape?: string;
  // The underlying cause when a datachecks/modality error wraps another error
  // (e.g. the JSONata custom function throwing "datastore handle not available").
  // Without this, only the generic wrapper message reaches the main thread.
  cause?: string;
  // The compiled JSONata expression that failed, when available.
  expression?: string;
};

export type WorkerErrorMessage = {
  type: 'error';
  message: string;
  stack?: string;
  name?: string;
  action: string;
  isGlobalError?: boolean;
  diagnostics?: WorkerErrorDiagnostics;
};

export type WorkerSuccessMessage<T> = {
  type?: 'success';
  action: string;
  result: T;
};

export type WorkerMessage<T = any> = WorkerErrorMessage | WorkerSuccessMessage<T>;

// Type guards for discriminating message types
export const isWorkerErrorMessage = (message: WorkerMessage): message is WorkerErrorMessage => {
  return message.type === 'error';
};

export type GetCanonicalResult = {
  canonical: Record<string, any>;
};

export type DatacheckError = {
  flat_dotnotation: string;
  failed_checks: Array<{ error: { title: string; description: string } }>;
  is_hidden: boolean;
};

export type ModalityError = {
  exists: boolean;
  modality: string;
  flat_dotnotation: string;
  field: { name: string };
  is_hidden: boolean;
  error_title: string | undefined;
  error_description: string | undefined;
};

export type GetCanonicalAndErrorsResult = {
  canonical: Record<string, any>;
  errors: {
    datachecks: Array<DatacheckError>;
    modality: Array<ModalityError>;
  };
};

export type GetUiDetailsResult = {
  view: Array<ui.Section>;
  values: Record<string, any>;
  debug?: unknown;
  canonical?: unknown;
};
